module.exports = __webpack_public_path__ + "fa-regular-400.woff?ef60a4f6c25ef7f39f2d25a748dbecfe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-regular-400.woff
// module id = 42
// module chunks = 0